<template>
  <div :class="$style.frameParent">
    <div :class="$style.frameGroup">
      <div :class="$style.studentInformationParent">
        <b :class="$style.studentInformationHeader">Student Information</b>
        <img
          :class="$style.closeIcon"
          alt=""
          src="/static/img/grey-x.svg"
          @click="closeModal"
        />
      </div>
      <div :class="$style.label">
        Be sure to keep this sensitive information confidential.
      </div>
    </div>
    <div :class="$style.studentOverflow">
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Name</div>
        <div :class="$style.studentParent">
          <div :class="$style.studentInformation">{{ student.firstName }}</div>
          <div :class="$style.studentInformation">{{ student.lastName }}</div>
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Birthday</div>
        <div :class="$style.studentParent">
          <div :class="$style.studentInformation">
            {{ student.birthday }}
          </div>
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Location</div>
        <div :class="$style.studentParent">
          <div :class="$style.studentInformation">{{ student.city }},</div>
          <div :class="$style.studentInformation">{{ student.state }}</div>
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Phone</div>
        <div :class="$style.studentAnswer">{{ student.phone }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Email</div>
        <div :class="$style.studentAnswer">{{ student.email }}</div>
      </div>

      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Which best describes your current role?
        </div>
        <div :class="$style.studentAnswer">{{ student.userTypeName }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Do you have flight experience?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.flightExperience ? "Yes" : "No" }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          How many hours do you have?
        </div>
        <div :class="$style.studentAnswer">{{ aboutYou.flightHours }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Which of these ratings do you have?
        </div>
        <div :class="$style.studentAnswer">{{ aboutYou.ratings }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          What or who inspired you to pursue a career in aviation?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.whoInspired }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          How do you handle challenges or setbacks?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.handleChallenges }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          In what environments do you learn best?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.learningEnvironments }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          What is one trait you possess that will make you a great pilot?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.personalityTrait }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          What are your long term goals both within and outside of aviation?
        </div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.longTermGoals }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          What is the highest level of education you have achieved?
        </div>
        <div :class="$style.studentAnswer">{{ aboutYou.educationLevelId }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Will you be training part time or full time?
        </div>
        <div :class="$style.studentAnswer">{{ aboutYou.fullOrPartTimeId }}</div>
      </div>
      <div
        v-for="(ref, index) in aboutYou.references"
        :key="index"
        :class="$style.referenceParent"
      >
        <div :class="$style.cosigner">Reference {{ index + 1 }}:</div>
        <div :class="$style.studentInformation">{{ ref.name || "None" }}</div>
        <div :class="$style.studentInformation">{{ ref.phone || "None" }}</div>
        <div :class="$style.studentInformation">{{ ref.email || "None" }}</div>
        <div :class="$style.studentInformation">
          {{ ref.relationship || "None" }}
        </div>
      </div>

      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Are you already connected with a flight school?
        </div>
        <div :class="$style.studentAnswer">
          {{ flightSchool.isConnectedToAFlightSchool ? "Yes" : "No" }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Flight school name</div>
        <div :class="$style.studentAnswer">
          {{ flightSchool.flightSchoolId }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          Flight school point of contact
        </div>
        <div :class="$style.studentAnswer">
          {{ flightSchool.pointOfContact }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Phone</div>
        <div :class="$style.studentAnswer">{{ flightSchool.phone }}</div>
      </div>
      <div :class="$style.referenceParent">
        <div :class="$style.cosigner">What is the flight school address?</div>
        <div :class="$style.studentInformation">{{ flightSchool.street }}</div>
        <div :class="$style.studentInformation">{{ flightSchool.city }}</div>
        <div :class="$style.studentInformation">{{ flightSchool.state }}</div>
        <div :class="$style.studentInformation">{{ flightSchool.zip }}</div>
        <div :class="$style.studentInformation">{{ flightSchool.country }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Height</div>
        <div :class="$style.studentParent">
          <div :class="$style.studentInformation">
            {{ aboutYou.heightFeet }} ft
          </div>
          <div :class="$style.studentInformation">
            {{ aboutYou.heightInches }} in
          </div>
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Weight</div>
        <div :class="$style.studentAnswer">{{ aboutYou.weight }} lbs</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Gender</div>
        <div :class="$style.studentAnswer">
          {{ aboutYou.genderId === 1 ? "Female" : "Male" }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">
          How do you plan to pay for flight school?
        </div>
        <div :class="$style.studentAnswer">
          {{ finance.financingMethodId === 1 ? "Cash" : "Financing" }}
        </div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Tuition amount</div>
        <div :class="$style.studentAnswer">${{ finance.tuitionAmount }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">Loan amount</div>
        <div :class="$style.studentAnswer">${{ finance.loanAmount }}</div>
      </div>
      <div :class="$style.nameParent">
        <div :class="$style.studentInformation">9 Digit SSN...</div>
        <div :class="$style.studentAnswer">{{ finance.ssn }}</div>
      </div>
      <div :class="$style.referenceParent">
        <div :class="$style.cosigner">Cosigner</div>
        <div :class="$style.studentParent">
          <div :class="$style.studentInformation">
            {{ cosigner.coSignerFirstName }}
          </div>
          <div :class="$style.studentInformation">
            {{ cosigner.coSignerLastName }}
          </div>
        </div>
        <div :class="$style.studentInformation">
          {{ cosigner.coSignerPhone }}
        </div>
        <div :class="$style.studentInformation">
          {{ cosigner.coSignerEmail }}
        </div>
        <div :class="$style.studentInformation">
          {{ cosigner.coSignerRelationshipId }}
        </div>
        <div :class="$style.studentInformation">{{ cosigner.coSignerSsn }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import UsersAPIService from "@/servicehandlers/UsersAPIService";
import SignUpAPIService from "@/servicehandlers/SignUpAPIService";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";

const usersAPIService = new UsersAPIService();
const signUpAPIService = new SignUpAPIService();
const aboutYouAPIService = new AboutYouAPIService();

export default defineComponent({
  name: "StudentInfoPopup",
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      student: {
        firstName: "",
        lastName: "",
        birthday: "",
        city: "",
        state: "",
        phone: "",
        email: "",
        genderId: "",
        userTypeName: "",
      },
      aboutYou: {
        userId: "",
        flightExperience: "",
        flightHours: "",
        ratings: "",
        whoInspired: "",
        handleChallenges: "",
        learningEnvironments: "",
        personalityTrait: "",
        longTermGoals: "",
        educationLevelId: "",
        fullOrPartTimeId: "",
        references: [],
        heightFeet: "",
        heightInches: "",
        weight: "",
      },
      flightSchool: {
        isConnectedToAFlightSchool: false,
        flightSchoolId: "",
        pointOfContact: "",
        phone: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
      finance: {
        financingMethodId: "",
        tuitionAmount: 0,
        loanAmount: 0,
        ssn: 0,
      },
      cosigner: {
        coSignerFirstName: "",
        coSignerLastName: "",
        coSignerPhone: 0,
        coSignerEmail: "",
        coSignerRelationshipId: "",
        coSignerSsn: 0,
      },
    };
  },
  methods: {
    async fetchStudentInfo() {
      try {
        this.loading = true;

        // student
        const studentData = await usersAPIService.getSignUpUserById(
          this.userId,
        );
        this.student = {
          firstName: studentData.firstName,
          lastName: studentData.lastName,
          birthday: studentData.dob,
          city: studentData.city,
          state: studentData.state,
          phone: studentData.phone,
          email: studentData.email,
          genderId: studentData.genderId,
          userTypeName: studentData.userType.name,
        };

        // about you
        const aboutYouData = await aboutYouAPIService.getStudentByUserId(
          this.userId,
        );
        const [
          relationshipsList,
          educationLevelsList,
          fullOrPartTimeList,
          learningEnvironmentsList,
          ratingsList,
        ] = await Promise.all([
          aboutYouAPIService.getRelationshipsList(),
          aboutYouAPIService.getEducationLevelsList(),
          aboutYouAPIService.getFullOrPartTimeList(),
          aboutYouAPIService.getLearningEnvironmentsList(),
          aboutYouAPIService.getRatingsList(),
        ]);

        const relationshipMap = Object.fromEntries(
          relationshipsList.map((item) => [String(item.id), item.name]),
        );
        const educationMap = Object.fromEntries(
          educationLevelsList.map((item) => [item.id, item.name]),
        );
        const fullOrPartTimeMap = Object.fromEntries(
          fullOrPartTimeList.map((item) => [item.id, item.name]),
        );
        const learningEnvironmentsMap = Object.fromEntries(
          learningEnvironmentsList.map((item) => [item.id, item.name]),
        );
        const ratingsMap = Object.fromEntries(
          ratingsList.map((item) => [item.id, item.name]),
        );

        const ratingsArray = (aboutYouData.ratings || []).map(
          (ratingId) => ratingsMap[ratingId] || "None",
        );
        const learningArray = (aboutYouData.learningEnvironments || []).map(
          (envId) => learningEnvironmentsMap[envId] || "None",
        );
        const ratingsString = ratingsArray.join(", ");
        const learningString = learningArray.join(", ");

        this.aboutYou = {
          flightExperience: aboutYouData.flightExperience,
          flightHours: aboutYouData.flightHours,
          whoInspired: aboutYouData.whoInspired,
          handleChallenges: aboutYouData.handleChallenges,
          personalityTrait: aboutYouData.personalityTrait,
          longTermGoals: aboutYouData.longTermGoals,
          heightFeet: aboutYouData.heightFeet,
          heightInches: aboutYouData.heightInches,
          weight: aboutYouData.weight,
          educationLevelId:
            educationMap[aboutYouData.educationLevelId] || "None",
          fullOrPartTimeId:
            fullOrPartTimeMap[aboutYouData.fullOrPartTimeId] || "None",
          ratings: ratingsString,
          learningEnvironments: learningString,
          references: (aboutYouData.references || []).map((ref) => ({
            name: ref.name || "None",
            phone: ref.phone || "None",
            email: ref.email || "None",
            relationship: relationshipMap[String(ref.relationshipId)] || "None",
          })),
        };
        if (this.aboutYou.references.length === 0) {
          this.aboutYou.references = [
            { name: "", phone: "", email: "", relationshipId: "" },
            { name: "", phone: "", email: "", relationshipId: "" },
          ];
        }

        // flight school
        const flightData = await signUpAPIService.getUserFlightSchool(
          this.userId,
        );
        this.flightSchool = {
          isConnectedToAFlightSchool:
            flightData.isConnectedToAFlightSchool || false,
          flightSchoolId: flightData.flightSchool?.name || "None",
          pointOfContact: flightData.flightSchool?.contact || "None",
          phone: flightData.flightSchool?.phone || "None",
          street: flightData.flightSchool?.address1 || "None",
          city: flightData.flightSchool?.city || "None",
          state: flightData.flightSchool?.state || "None",
          zip: flightData.flightSchool?.zip || "None",
          country: flightData.flightSchool?.country || "None",
        };

        // financing
        const financeData = await signUpAPIService.getUserFinancing(
          this.userId,
        );
        this.finance = {
          financingMethodId: financeData.financingMethodId,
          tuitionAmount: financeData.tuitionAmount.toLocaleString() || 0,
          loanAmount: financeData.loanAmount.toLocaleString() || 0,
          ssn: financeData.ssn || 0,
        };

        this.cosigner = {
          coSignerFirstName: financeData.firstName || "None",
          coSignerLastName: financeData.lastName || "",
          coSignerPhone: financeData.phone || "None",
          coSignerEmail: financeData.email || "None",
          coSignerRelationshipId: financeData.relationshipId || "None",
          coSignerSsn: financeData.ssn || "None",
        };
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
  async mounted() {
    await this.fetchStudentInfo();
  },
});
</script>

<style module scoped>
.studentOverflow {
  overflow-y: auto;
}
.studentInformationParent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  position: relative;
}
.studentInformationHeader {
  font-size: 25px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  font-weight: bold;
  flex-grow: 1;
  text-align: center;
}
.studentInformation {
  position: relative;
}
.closeIcon {
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.label {
  align-self: stretch;
  position: relative;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
}
.frameGroup {
  align-self: stretch;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 30px;
  color: #404040;
}
.studentParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: #404040;
}
.nameParent {
  align-self: stretch;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 30px;
}
.studentAnswer {
  position: relative;
  color: #404040;
  word-wrap: break-word;
  width: 700px;
}
.referenceParent {
  align-self: stretch;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: #404040;
  margin-bottom: 30px;
}
.cosigner {
  position: relative;
  color: rgba(64, 64, 64, 0.5);
}
.frameParent {
  width: 100%;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 30px;
  text-align: left;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
  font-family: Helvetica, Arial, sans-serif;
  height: 900px;
}
</style>
